import ClientsPage from './clients';

export default ClientsPage;
